/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { Card, Grid, Typography } from '@mui/material';
import { shadowColor } from 'theme/color';
import { ReactComponent as Clock } from 'assets/icons/clock.svg';
import { ReactComponent as Green } from 'assets/icons/green.svg';
import { ReactComponent as Yellow } from 'assets/icons/yellow.svg';
import { ReactComponent as Red } from 'assets/icons/red.svg';
import { ReactComponent as ArrowDown } from 'assets/icons/arrowDown.svg';
import { ReactComponent as Eye } from 'assets/icons/eye.svg';
import { ReactComponent as Logo } from 'assets/svg/Logo.svg';

import {
  displayFlex,
  displayFlexColumn,
  fontsize12,
  fontsize16,
  fontsize24,
  poppins300,
  poppins500,
} from 'theme/common.style';
import {
  dayDispContainer,
  dayTextBottom,
  dayTextFont,
  seperator,
  termsCondition,
} from './PropertyProfile.style';

function PropertyOffer(props) {
  return (
    <Card
      variant="outlined"
      style={{
        borderRadius: '8px',
        boxShadow: `0px 1px 8px ${shadowColor}`,
        padding: '30px 20px',
      }}
    >
      <Grid
        container
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        spacing={1}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Grid item sx={displayFlex} xs={5} sm={5} md={5} lg={5} xl={5}>
          <Typography
            style={{
              position: 'relative',
              top: '7px',
              paddingRight: '4px',
            }}
          >
            <Clock />
          </Typography>
          <Typography sx={displayFlexColumn}>
            <Typography sx={{ ...poppins500, ...fontsize24 }}>
              Offers close in:
            </Typography>
            <Typography>
              How does retreX Offer Management System work?
            </Typography>
          </Typography>
        </Grid>
        <Grid
          item
          xs={3}
          sm={3}
          md={3}
          lg={3}
          xl={3}
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{ ...displayFlex }}
            style={{
              alignItems: 'flex-end',
              border: '1px solid #EEEFF1',
              borderRadius: '8px',
              paddingBottom: '10px',
              paddingTop: '4px',
              paddingRight: '10px',
              paddingLeft: '10px',
              justifyContent: 'space-evenly',
            }}
          >
            <Typography
              sx={{ ...poppins300, ...fontsize16 }}
              style={{
                paddingRight: '10px',
              }}
            >
              Market Sentiment
            </Typography>
            <Typography>
              <Typography sx={displayFlex}>
                <ArrowDown height={9} width={9} />
              </Typography>
              <Typography>
                <Green />
                <Yellow />
                <Red />
              </Typography>
            </Typography>
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          sm={4}
          md={4}
          lg={4}
          xl={4}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'end',
          }}
          gap={2}
        >
          <Typography
            sx={{ ...poppins300, ...fontsize16 }}
            style={{
              border: '1px solid #EEEFF1',
              borderRadius: '8px',
              padding: '10px',
            }}
          >
            <Eye width={18} height={10} />
            Watch
          </Typography>
          <Typography
            sx={{ ...poppins300, ...fontsize16 }}
            style={{
              border: '1px solid #EEEFF1',
              borderRadius: '8px',
              padding: '10px',
            }}
          >
            Insights
          </Typography>
        </Grid>
      </Grid>
      <Grid
        style={{
          padding: '30px 0px 10px 18px',
        }}
        sx={displayFlex}
        container
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        spacing={1}
      >
        <Grid item xs={10} sm={10} md={10} lg={9} xl={9} sx={displayFlex}>
          <Grid
            sx={displayFlex}
            container
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            gap={2}
          >
            <Grid sx={{ ...displayFlexColumn, ...dayDispContainer }}>
              <Typography sx={dayTextFont}>11</Typography>
              <Typography sx={dayTextBottom}>Days</Typography>
            </Grid>
            <Grid sx={seperator}>:</Grid>
            <Grid sx={{ ...displayFlexColumn, ...dayDispContainer }}>
              <Typography sx={dayTextFont}>11</Typography>
              <Typography sx={dayTextBottom}>Hours</Typography>
            </Grid>
            <Grid sx={seperator}>:</Grid>
            <Grid sx={{ ...displayFlexColumn, ...dayDispContainer }}>
              <Typography sx={dayTextFont}>11</Typography>
              <Typography sx={dayTextBottom}>Minutes</Typography>
            </Grid>
            <Grid sx={seperator}>:</Grid>
            <Grid sx={{ ...displayFlexColumn, ...dayDispContainer }}>
              <Typography sx={dayTextFont}>11</Typography>
              <Typography sx={dayTextBottom}>Seconds</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={2} sm={2} md={2} lg={3} xl={3} sx={displayFlexColumn}>
          <Typography sx={termsCondition}>Term & Conditions</Typography>
          <Typography
            sx={displayFlex}
            style={{
              paddingTop: '8px',
              justifyContent: 'end',
            }}
          >
            <Typography
              sx={{
                ...poppins300,
                ...fontsize12,
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Powered by
            </Typography>
            <Typography>
              <Logo width={100} height={50} />
            </Typography>
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
}

PropertyOffer.propTypes = {};

export default PropertyOffer;
